import React from 'react'
import { LabelForRoute, Link, useOnNavigate, useRouter } from '@morningtrain/react-navigation'
import { Env } from '@morningtrain/helpers'
import * as Auth from '@morningtrain/react-auth'
import SidebarMenuItem from 'ui/navigation/SidebarMenuItem'

function MenuItem (props) {
  const router = useRouter()

  const isRouteActive = (route) => {
    const parent = Env.get('page.parent')
    const currentPageParents = Env.get('page.parents', [])

    if (route && route === parent) {
      return true
    }

    if (route === router.currentRoute) {
      return true
    }

    if (currentPageParents.length > 0) {
      let anyParentIsActive = false

      currentPageParents.forEach(parent => {
        if (parent && parent.ignoreWhenActive !== true && parent.route && parent.route === route) {
          anyParentIsActive = true
        }
      })

      if (anyParentIsActive) {
        return true
      }
    }

    return false
  }

  const hasLink = !!props.route

  const checkIfActive = () => {
    if (props.route && isRouteActive(props.route)) {
      return true
    }

    return false
  }

  const [isActive, setIsActive] = React.useState(checkIfActive())

  useOnNavigate(() => {
    setIsActive(checkIfActive())
  })

  const handleOnClick = (e) => {
    if (typeof props.onClick === 'function') {
      props.onClick(e.target)
    }
  }

  const Item = (
    hasLink
      ? (
        <Link className='block group' route={props.route} onClick={handleOnClick} {...(props.linkProps || {})}>
          <SidebarMenuItem
            active={isActive}
            text={<LabelForRoute label={props.label} route={props.route} />}
            svgIcon={props.svgIcon}
            hasStatusBar={props.hasStatusBar}
          />
        </Link>
        )
      : (
        <div className='block group' onClick={handleOnClick}>
          <SidebarMenuItem
            active={isActive}
            text={<LabelForRoute label={props.label} route={props.route} />}
            svgIcon={props.svgIcon}
            hasStatusBar={props.hasStatusBar}
          />
        </div>
        )
  )

  if (props.route) {
    return (
      <Auth.Can permission={props.route}>
        {Item}
      </Auth.Can>
    )
  }

  return Item
}

export default MenuItem
